module.exports = __webpack_public_path__ + "img/DFW_Shield.7f9a773d.png";